/**
 * get a unique list of objects by key
 * @param arr any[]
 * @param key string
 * @returns array
 */
export const getUniqueListBy = (arr: any[], key: string) => {
  return [...new Map(arr.map((item) => [item[key], item])).values()];
};
